module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-wrap-max",
    staticStyle: {
      "height": "100vh"
    },
    attrs: {
      "id": "wrap"
    }
  }, [_c('section', {
    staticClass: "sp-boarding-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "sp-boarding-centered"
  }, [_c('div', {
    staticClass: "sp-pan-left-inner"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "padding-top-10 padding-bottom-10"
  }, [_c('p', {
    staticClass: "text-center",
    staticStyle: {
      "font-size": "12px",
      "color": "#2d3a4b",
      "text-decoration": "underline"
    }
  }, [_vm._v("Log In")]), _vm._v(" "), _c('div', {
    staticClass: "sp-inner-form-wrap"
  }, [_c('form', {
    staticClass: "form sp-forms-one"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Email Address\r\n                                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Password\r\n                                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")])])])])])]), _vm._v(" "), _vm._m(1)])])])])]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-image text-center"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "static/assets/images/logo.png",
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "12px",
      "text-align": "center"
    }
  }, [_vm._v("Dont have an Account?"), _c('br'), _c('a', {
    attrs: {
      "href": "register"
    }
  }, [_c('u', [_vm._v("Create an Account ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-footer-2"
  }, [_c('div', {
    staticClass: "foot-links"
  }, [_c('a', {
    attrs: {
      "href": "info#about"
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "info#about"
    }
  }, [_vm._v("Support")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "info#about"
    }
  }, [_vm._v("Terms")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "info#about"
    }
  }, [_vm._v("How to use")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _vm._v(" "), _c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("©  2015 Sellpoint. All rights reserved. ")]), _vm._v(" "), _c('div', {
    staticClass: "scroll"
  }, [_c('a', {
    staticClass: "go-up",
    attrs: {
      "href": "#wrap"
    }
  }, [_c('i', {
    staticClass: "lnr lnr-arrow-up"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac7df29c"}!./src/pages/Login/template.html
// module id = 295
// module chunks = 0